import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import {
  CHECKOUT_TEXT,
  isLoopReturnsActive,
  PROCESSING_TEXT,
  submitLoopStore,
  useCartData,
} from '../../../../utils/cart';
import ButtonWithProgress from 'src/scripts/templates/_shared/ui-components/YogaUI/ButtonWithProgress';

const CartCheckoutButton = ({ options = {} }: { options?: CartCheckoutButtonOptions }) => {
  const { buttonClasses = '', showSpinner = true } = options;
  const cartData = useCartData();
  const { checkoutUrl, regularItems, subtotal } = cartData;
  const [isProcessing, setIsProcessing] = useState(false);

  const loadCheckoutPage = () => {
    if (showSpinner) setIsProcessing(true);
    if (isLoopReturnsActive()) {
      submitLoopStore();
    } else {
      if (checkoutUrl) window.location.href = checkoutUrl;
    }
  };

  const disableCartButton = subtotal === 0 && (!regularItems || regularItems.length === 0);

  return (
    <ButtonWithProgress
      options={{
        showProgressAnimation: isProcessing,
        cta: isProcessing ? PROCESSING_TEXT : CHECKOUT_TEXT,
        wrapperClasses: 'checkout-button-wrapper',
        buttonClasses: `btn-block btn__checkout ${buttonClasses}`,
        disableShrink: true,
        disabled: disableCartButton,
        onClick: loadCheckoutPage,
        tabIndex: 0,
      }}
    />
  );
};

interface CartCheckoutButtonOptions {
  buttonClasses?: string;
  showSpinner?: boolean;
}

export default CartCheckoutButton;

export const renderCartCheckoutButton = () => {
  const mountNodes = document.querySelectorAll("[react-render-target='cart-checkout-button']");
  mountNodes.forEach((mountNode) => {
    ReactDOM.render(<CartCheckoutButton />, mountNode);
  });
};
